<template>
    <div v-if="results" class="poi">
        <h3 class="display-4">Explore the area</h3>
        <ul class="list-unstyled">
            <li class="item mb-2" v-for="item in results" :key="item.id" :data-type="item.category">
                <a :href="'https://www.google.com/maps/dir/?api=1&amp;origin=' + result.hotel.latitude + ',' + result.hotel.longitude + '&amp;destination=' + item.geoCode.latitude + ',' + item.geoCode.longitude + '&amp;travelmode=hybrid'" target="_blank">
                    <font-awesome-icon v-if="item.category == 'DISTRICT'" :icon="['fas', 'city']" size="lg" />
                    <font-awesome-icon v-else-if="item.category == 'AIRPORT'" :icon="['fas', 'plane']" size="lg" />
                    <font-awesome-icon v-else-if="item.category == 'RESTAURANT'" :icon="['fas', 'utensils']" size="lg" />
                    <font-awesome-icon v-else-if="item.category == 'SHOPPING'" :icon="['fas', 'map-marker-alt']" size="lg" />
                    <font-awesome-icon v-else-if="item.category == 'NIGHTLIFE'" :icon="['fas', 'map-marker-alt']" size="lg" />
                    <font-awesome-icon v-else :icon="['fas', 'map-marker-alt']" size="lg" />
                    <span class="ml-2">{{ item.name }}</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    import axios from "axios"

    import { library } from '@fortawesome/fontawesome-svg-core'
    import { 
        faMapMarkerAlt,
        faPlane,
        faCity,
        faUtensils,
    } from '@fortawesome/free-solid-svg-icons'

    library.add(faMapMarkerAlt)
    library.add(faPlane)
    library.add(faCity)
    library.add(faUtensils)

    export default {
        name: 'PoiList',
        props: {
            result: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                results: [],
            }
        },
        components: {},
        methods: {
            loadResults() {
                axios
                    .get('https://api.stay.com.de/?action=poi-near' +
                        '&lat=' + this.result.hotel.latitude + 
                        '&lng=' + this.result.hotel.longitude
                    )
                    .then(response => {
                        this.results = response.data.data;
                    })
                ;
            }
        },
        mounted() {
            this.loadResults();
        }
    }
</script>

<style scoped>
</style>